import React from 'react';
import styled from 'styled-components';
import { useCustomerViewModel } from '../viewmodels/CustomerViewModel';
import { CustomerLimitOption } from '../models/CustomerModels';
import CustomerSearchBarMobile from '../components/CustomerSearchBarMobile';
import CustomerListTableMobile from '../components/CustomerListTableMobile';
import PaginationMobile from '../components/PaginationMobile';
import PageHeader from '../components/ui/PageHeader';
import { colors, typography, spacing, borderRadius } from '../styles/designTokens';

// 모바일 페이지 메인 컨테이너 - 밀도 있는 디자인
const MobilePageContainer = styled.div`
  padding: ${spacing[3]} ${spacing[3]};
  min-height: 100vh;
  background-color: ${colors.secondary[50]};
  padding-bottom: 100px;

  @media (max-width: 768px) {
    padding: ${spacing[2]} ${spacing[2]};
    padding-bottom: 100px;
  }
`;

// 모바일 콘텐츠 영역 스타일 - 밀도 있게
const MobileContentArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

// 모바일 에러 메시지 스타일 - 컴팩트
const MobileErrorMessage = styled.div`
  background: ${colors.error[50]};
  border: 1px solid ${colors.error[200]};
  color: ${colors.error[600]};
  padding: ${spacing[2]} ${spacing[3]};
  border-radius: ${borderRadius.md};
  text-align: center;
  font-size: ${typography.fontSize.xs};
  margin: ${spacing[2]} 0;
  line-height: ${typography.lineHeight.relaxed};
`;

// 모바일 고객 관리 페이지 컴포넌트
const CustomersMobile: React.FC = () => {
  // ViewModel 훅 사용 (기존과 동일)
  const {
    customers,
    loading,
    error,
    searchQuery,
    currentPage,
    limit,
    totalPages,
    total,
    handleSearch,
    handlePageChange,
    handleLimitChange,
    refreshData,
    formatDateTime,
    formatCurrency,
    formatMarketingStatus
  } = useCustomerViewModel();

  return (
    <MobilePageContainer>
      <PageHeader
        variant="compact"
        title="고객 관리"
        description="등록된 고객 정보를 조회하고 관리할 수 있습니다."
      />

      {/* 모바일 콘텐츠 영역 */}
      <MobileContentArea>
        {/* 모바일 검색 바 */}
        <CustomerSearchBarMobile
          searchQuery={searchQuery}
          limit={limit}
          total={total}
          loading={loading}
          onSearch={handleSearch}
          onLimitChange={(newLimit: number) => handleLimitChange(newLimit as CustomerLimitOption)}
          onRefresh={refreshData}
        />

        {/* 모바일 에러 메시지 */}
        {error && (
          <MobileErrorMessage>
            {error}
          </MobileErrorMessage>
        )}

        {/* 모바일 고객 목록 테이블 */}
        <CustomerListTableMobile
          customers={customers}
          loading={loading}
          formatDateTime={formatDateTime}
          formatCurrency={formatCurrency}
          formatMarketingStatus={formatMarketingStatus}
        />

        {/* 모바일 페이지네이션 */}
        {!loading && !error && (
          <PaginationMobile
            currentPage={currentPage}
            totalPages={totalPages}
            total={total}
            limit={limit}
            onPageChange={handlePageChange}
          />
        )}
      </MobileContentArea>
    </MobilePageContainer>
  );
};

export default CustomersMobile; 